import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "parts/Cards/BlogCards/CenteredBlogCard";
// Image
import bgImage from "assets/images/contact.jpg";
function Information() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        pt: "100px",  // Adds space at the top to avoid overlap with fixed navbar
      }}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="User Research"
                    description="Deep Insights to Drive Design Decisions
Successful product design starts with understanding the people who will use it. Our user research process involves analyzing user behavior, preferences, and pain points to inform every design choice. Through methods such as surveys, interviews, and analytics, we gather valuable insights that shape designs that truly meet your users' needs."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Wireframing & Prototyping"
                    description="Visualizing Ideas with Precision and Clarity
We create wireframes and prototypes that map out the structure and flow of your product, providing a visual representation of how users will interact with it. Whether you need low-fidelity wireframes to explore early concepts or high-fidelity prototypes to simulate the final product experience, our designs lay the groundwork for seamless user interfaces and intuitive experiences."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Usability Testing"
                    description="Refining Designs Through Real User Feedback
Our usability testing process ensures that your product is not only functional but also intuitive and easy to use. By gathering feedback from actual users, we can identify pain points, improve design elements, and fine-tune the user experience. This iterative testing approach allows us to refine your product to meet user expectations and drive higher satisfaction."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Interaction Design"
                    description="Engaging Users with Intuitive Interactions
Interaction design is about creating smooth, engaging, and purposeful interactions between users and your product. We design intuitive animations, transitions, and microinteractions that enhance user engagement and ensure a cohesive, responsive experience across all touchpoints. From simple button clicks to complex workflows, our interaction designs keep users engaged and satisfied throughout their journey."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgImage}
              title="Get insights"
              description="In today's rapidly evolving digital landscape, staying informed is key to making smart decisions. At HP Tech Solutions, we provide valuable insights into the latest trends, challenges, and opportunities in software development and cybersecurity."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Contact",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
